import { DataTextureTypedArray, Texture, bufferToDataType } from "./texture";
import { Chunk } from "../../data/chunk";

export class Texture3D extends Texture {
  private readonly width_: number;
  private readonly height_: number;
  private readonly depth_: number;

  constructor(
    data: DataTextureTypedArray,
    width: number,
    height: number,
    depth: number
  ) {
    super();
    this.dataFormat = "scalar";
    this.dataType = bufferToDataType(data);

    this.data_ = data;
    this.width_ = width;
    this.height_ = height;
    this.depth_ = depth;
  }

  public get type() {
    return "Texture3D";
  }

  public get width() {
    return this.width_;
  }

  public get height() {
    return this.height_;
  }

  public get depth() {
    return this.depth_;
  }

  public static createWithChunk(chunk: Chunk) {
    const source = chunk.data;
    if (!source) {
      throw new Error(
        "Unable to create texture, chunk data is not initialized."
      );
    }

    const texture = new Texture3D(
      source,
      chunk.shape.x,
      chunk.shape.y,
      chunk.shape.z
    );
    texture.unpackAlignment = chunk.rowAlignmentBytes;
    return texture;
  }
}
